import React from "react"

import CurrentLink from 'app/dodones/shared/CurrentLink'
import DodoneContext from 'app/dodones/Context';
import DodoneFinishButton from 'app/dodones/shared/FinishButton';
import DodoneStartButton from 'app/dodones/shared/StartButton'
import DodoneStats from 'app/dodones/shared/Stats'
import DodonesList from 'app/dodones/list/Index'
import HeaderContext from 'app/HeaderContext'
import Tabs from 'app/layout/Tabs'
import { format } from 'date-fns'
import { useContext, useEffect } from "react"

const StartedDay = () => {
  const { dodone } = useContext(DodoneContext);

  const tabs = [
    { key: 'today', text: "Today", element: <DodonesList dodones={ dodone.children } /> },
    { key: 'free', text: "Free", element: <div> Oe </div> },
  ]

  const somePending = dodone.children.some((dodone) => {
    return dodone.pending;
  })

  const showFinishButton = !somePending && !dodone.isFinished;

  return <div className="fcol flex-1">
           <Tabs tabs={ tabs } selected="today" />
           { showFinishButton ? <DodoneFinishButton text="Caboooo cabo o dia" /> : null }
         </div>;
}

const PreviousDayWarning = ({ dodone }) => {
  return <div className="mb-d">
           {
             dodone.isPrevious() ?
               <div className="orange-transparent-box py-2">
                 <div className="text-center pb-1 text-xl"> Esqueceu seu tonto </div>
                 { dodone.isFinished ? <div className="text-lg text-center"><CurrentLink /></div> : null }
               </div>: null
           }
         </div>
}

const FinishedDay = () => {
  const { dodone } = useContext(DodoneContext);

  return <DodoneStats dodone={ dodone } />
}

export default () => {
  const { setText } = useContext(HeaderContext);
  const { dodone } = useContext(DodoneContext);

  useEffect(() => {
    setText(format(dodone.day, 'E, MMM dd'))
  }, [dodone.id]);

  return <>
           <PreviousDayWarning dodone={ dodone } />
           { dodone.isNotStarted ? <><div className="flex-1"></div><DodoneStartButton text="Start Day" /></> : null }
           { dodone.isStarted ? <StartedDay /> : null }
           { dodone.isFinished ? <FinishedDay /> : null }
         </>
};
